export default "__VITE_ASSET__DurZqeak__"